import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  ${tokens.mediaQueries.s} {
    margin-bottom: 0;
    min-height: 40px;
    display: flex;
    align-items: center;
  }
`;

export const Content = styled.button`
  cursor: pointer;
  position: relative;

  ${tokens.mediaQueries.m} {
    outline: none;
  }

  ${tokens.mediaQueries.l} {
    outline: none;
  }

  ${tokens.mediaQueries.s} {
    height: 100%;
    box-sizing: border-box;
    padding: 0 ${tokens.space.regular};
  }
`;

type ButtonTextProps = {
  isOpen?: boolean;
};

export const ButtonText = styled.span<ButtonTextProps>`
  position: unset;
  color: ${tokens.colors.primary};
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.s};
  white-space: nowrap;

  ${tokens.mediaQueries.s} {
    font-weight: ${({ isOpen }): string => (isOpen ? 'bold' : 'normal')};
  }
`;
